<template>
  <div class="gotedo-loading-spinner d-flex mx-auto my-auto">
    <div class="spinner-container">
      <div></div>
      <div></div>
      <div>
        <div></div>
      </div>
      <div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GotedoSpinnerLoader',
};
</script>
<style type="text/css">
@keyframes spinner-container {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner-container div {
  box-sizing: border-box !important;
}
.spinner-container > div {
  position: absolute;
  width: 45px;
  height: 45px;
  top: 27.5px;
  left: 27.5px;
  border-radius: 50%;
  border: 5px solid #000;
  border-color: #0064b2 transparent #0064b2 transparent;
  animation: spinner-container 0.6666666666666666s linear infinite;
}

.spinner-container > div:nth-child(2),
.spinner-container > div:nth-child(4) {
  width: 33px;
  height: 33px;
  top: 33.5px;
  left: 33.5px;
  animation: spinner-container 0.6666666666666666s linear infinite reverse;
}
.spinner-container > div:nth-child(2) {
  border-color: transparent #ffa823 transparent #ffa823;
}
.spinner-container > div:nth-child(3) {
  border-color: transparent;
}
.spinner-container > div:nth-child(3) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.spinner-container > div:nth-child(3) div:before,
.spinner-container > div:nth-child(3) div:after {
  content: '';
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  top: -5px;
  left: 15px;
  background: #0064b2;
  border-radius: 50%;
  box-shadow: 0 40px 0 0 #0064b2;
}
.spinner-container > div:nth-child(3) div:after {
  left: -5px;
  top: 15px;
  box-shadow: 40px 0 0 0 #0064b2;
}

.spinner-container > div:nth-child(4) {
  border-color: transparent;
}
.spinner-container > div:nth-child(4) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.spinner-container > div:nth-child(4) div:before,
.spinner-container > div:nth-child(4) div:after {
  content: '';
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  top: -5px;
  left: 9px;
  background: #ffa823;
  border-radius: 50%;
  box-shadow: 0 28px 0 0 #ffa823;
}
.spinner-container > div:nth-child(4) div:after {
  left: -5px;
  top: 9px;
  box-shadow: 28px 0 0 0 #ffa823;
}
.gotedo-loading-spinner {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: rgba(NaN, NaN, NaN, 0);
}
.spinner-container {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.spinner-container div {
  box-sizing: content-box;
}
</style>
